import { api } from "@/api";
import { sleep } from "@/shared/utils";

interface CajaAssignResponse{
    id:string,
    nombre:string,
    abierto:boolean,
    token:string
}

export async function assignCaja(cajaId: string): Promise<CajaAssignResponse> {
    await sleep(1000);
    const response = await api.post("caja_actual/assign/" + cajaId);
    return response.data;
}